// bon rendu => mettre des "values(count)" plus realistes
const dataCapitalStructure = [
  { capitalStructure: 'Cash', overvaluationReason: 'Assets', count : 3 },
  { capitalStructure: 'Other Assets', overvaluationReason: 'Assets', count : 7 },
  
  { capitalStructure: 'Net Debt', overvaluationReason: 'Liabilities', count : 3 },
  { capitalStructure: 'Pref. Shares', overvaluationReason: 'Liabilities', count : 1 },
  { capitalStructure: 'Equity', overvaluationReason: 'Liabilities', count : 6 },

];

export default dataCapitalStructure;

